/* eslint-disable jira/i18n/id-named-by-package */
import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	title: {
		id: 'eoc-changeboarding.wizard.steps.two.title-no-translate',
		defaultMessage: 'What happens to users and roles',
		description: 'Title of step two',
	},
	description: {
		id: 'eoc-changeboarding.wizard.steps.two.description-no-translate',
		defaultMessage:
			"After users and roles are synced, you'll need to assign a product role to Opsgenie users who don't have the same role in Jira Service Management.",
		description: 'Description of step two',
	},
	usersNeedAdminRole: {
		id: 'eoc-changeboarding.wizard.steps.two.users-need-admin-role-no-translate',
		defaultMessage:
			"{userAmount, plural, one {{userAmount} Opsgenie user} other {{userAmount} Opsgenie users}} won't have the same role in Jira",
		description: 'The indicator that shows how many users need the Jira admin role',
	},
});
